 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVERIMAGE from '@/components/CoverImage'
 import BACKEDBIRDSFRONT_1 from '@/components/Backed/birdsfront_1'
 import TITLE from '@/components/title'
 import CONJUNCTIONS from '@/components/conjunctions'
 import CONTENTS56 from '@/components/contents56'
 import EDNOTE7 from '@/components/ednote7'
 import CARRILLO817 from '@/components/carrillo817'
 import STEGER1822 from '@/components/steger1822'
 import HODGEN2336 from '@/components/hodgen2336'
 import STRAUB3744 from '@/components/straub3744'
 import VANDENBERG4562 from '@/components/vandenberg4562'
 import OLSEN6377 from '@/components/olsen6377'
 import PARRAS78102 from '@/components/parras78102'
 import WELISH103111 from '@/components/welish103111'
 import WEST112124 from '@/components/west112124'
 import BAUDELAIRE125145 from '@/components/baudelaire125145'
 import CHERNOFF146150 from '@/components/chernoff146150'
 import EVENSON151160 from '@/components/evenson151160'
 import HEMLEY161176 from '@/components/hemley161176'
 import MEIDAV177189 from '@/components/meidav177189'
 import OCONNOR190214 from '@/components/oconnor190214'
 import CONOLEY215226 from '@/components/conoley215226'
 import XUE227240 from '@/components/xue227240'
 import RIKER241262 from '@/components/riker241262'
 import WEITZEL263280 from '@/components/weitzel263280'
 import PITT281295 from '@/components/pitt281295'
 import SZE296301 from '@/components/sze296301'
 import BLACKWELL302315 from '@/components/blackwell302315'
 import CARTER316328 from '@/components/carter316328'
 import CONTRIBUTORS329331 from '@/components/contributors329331'
 import PDFCOPYRIGHT1 from '@/components/PDFcopyright1'
 import BACKEDBACKAD_1 from '@/components/Backed/backad_1'
 import A8AD2 from '@/components/58ad2'
 import BACKEDORIMAD_1 from '@/components/Backed/ORIMad_1'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/CoverImage",
 			"name" : "CoverImage",
 			"component" : COVERIMAGE
 		},
 		{
 			"path" : "/Backed/birdsfront_1",
 			"name" : "Backed/birdsfront_1",
 			"component" : BACKEDBIRDSFRONT_1
 		},
 		{
 			"path" : "/title",
 			"name" : "title",
 			"component" : TITLE
 		},
 		{
 			"path" : "/conjunctions",
 			"name" : "conjunctions",
 			"component" : CONJUNCTIONS
 		},
 		{
 			"path" : "/contents56",
 			"name" : "contents56",
 			"component" : CONTENTS56
 		},
 		{
 			"path" : "/ednote7",
 			"name" : "ednote7",
 			"component" : EDNOTE7
 		},
 		{
 			"path" : "/carrillo817",
 			"name" : "carrillo817",
 			"component" : CARRILLO817
 		},
 		{
 			"path" : "/steger1822",
 			"name" : "steger1822",
 			"component" : STEGER1822
 		},
 		{
 			"path" : "/hodgen2336",
 			"name" : "hodgen2336",
 			"component" : HODGEN2336
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js